// import required libraries
import $ from "jquery";

// import components that run on every page
import Aos from "./components/aos";

// Import Pages
import accessibility from "./actions/accessibility";
import navToggle from "./actions/navToggle";
import subMenuToggle from "./actions/subMenuToggle";
import MobileSlider from "./components/mobileSlider";
import TabletSlider from "./components/tabletSlider";
import PageFrontPage from "./pages/PageFrontPage";
import PageArtistIndex from "./pages/PageArtistIndex";
import PagePartnership from "./pages/PagePartnerships";
import PageProgramIndex from "./pages/PageProgramIndex";
import PageStaff from "./pages/PageStaff";
import PageSingleArtist from "./pages/PageSingleArtist";
import PageSingleProgram from "./pages/PageSingleProgram";
import PageSingleEvent from "./pages/PageSingleEvent";
import Page404 from "./pages/Page404";

// call functions
Aos();
accessibility();
navToggle($);
subMenuToggle($);
MobileSlider($);
TabletSlider($);
PageFrontPage($);
PageArtistIndex($);
PageStaff($);
PageProgramIndex($);
PageSingleArtist($);
PageSingleProgram($);
PageSingleEvent($);
Page404($);
PagePartnership($);
